import React from 'react';
import styled from 'styled-components';
import { GhostButton } from './surveyTheme.styles';

const Shell = styled.section`
  display: flex;
  min-height: min(520px, calc(100vh - 8rem));
  align-items: center;
  justify-content: center;
  padding: 2rem 0;

  @media (max-width: 640px) {
    /* Not centered on mobile: min-height: calc(100vh - 5rem) reserved nearly
       the full viewport, and centering the panel inside that left a large gap
       above it, under the header. It now sits right under the header instead. */
    min-height: 0;
    align-items: flex-start;
    padding: 1rem 0;
  }
`;

const Panel = styled.div`
  width: 100%;
  max-width: 760px;
  border: 1px solid rgba(216, 184, 137, 0.24);
  border-radius: 22px;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.98) 0%, rgba(249, 246, 241, 0.94) 100%);
  box-shadow: 0 14px 34px rgba(15, 23, 42, 0.07);
  padding: clamp(1.5rem, 4vw, 3rem);
  text-align: center;

  @media (max-width: 640px) {
    border-radius: 18px;
  }
`;

const Title = styled.h1`
  max-width: 680px;
  margin: 0 auto 1rem;
  color: var(--text-primary);
  font-size: clamp(1.15rem, 3.2vw, 1.75rem);
  font-weight: 700;
  letter-spacing: 0;
  line-height: 1.18;
  overflow-wrap: anywhere;
`;

const Message = styled.p`
  max-width: 660px;
  margin: 0 auto;
  color: var(--text-secondary);
  font-size: clamp(0.98rem, 2vw, 1.08rem);
  line-height: 1.65;
`;

const Actions = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 1.5rem;

  @media (max-width: 520px) {
    ${GhostButton} {
      width: 100%;
      justify-content: center;
      white-space: normal;
    }
  }
`;

export const SURVEY_COMPLETION_TITLE = 'Your Feedback Is Appreciated — Jazak Allahu Khayran! ❤️';
export const SURVEY_COMPLETION_MESSAGE = 'Thank you for being part of Faith Insight Foundations! We pray your experience has been meaningful and beneficial and we look forward to welcoming you back to a future class Insha Allah.';

export default function SurveyCompletionMessage({ onBackToSurveys }) {
  return (
    <Shell>
      <Panel>
        <Title>{SURVEY_COMPLETION_TITLE}</Title>
        <Message>{SURVEY_COMPLETION_MESSAGE}</Message>
        {onBackToSurveys && (
          <Actions>
            <GhostButton type="button" onClick={onBackToSurveys}>Back to My Surveys</GhostButton>
          </Actions>
        )}
      </Panel>
    </Shell>
  );
}
